import React from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router';
import PropTypes from 'prop-types';
import { bindActionCreators } from 'redux';
// import PullToRefresh from 'react-pullable';
import { appointmentActions, referralActions, redirectToRoute, headerActions } from 'actions';
import DateDivider from '../DateDivider';
import DataRow from '../DataRow';
import { HEADER } from '_constants';
import _ from 'lodash';
import ContentLoader from 'components/common/loaders/ContentLoader';

class AppointmentDetails extends React.Component {
  static propTypes = {
    appointmentsFetch: PropTypes.func.isRequired,
    referralFetch: PropTypes.func.isRequired,
    appointments: PropTypes.object.isRequired,
    referrals: PropTypes.object.isRequired,
    match: PropTypes.object.isRequired,
    setHeader: PropTypes.func.isRequired,
    cancelAppointment: PropTypes.func.isRequired,
    rescheduleAppointment: PropTypes.func.isRequired,
    completeAppointment: PropTypes.func.isRequired,
    navigateToReferralDetailPage: PropTypes.func.isRequired
  }

  componentDidMount () {
    this.initilizeAppointmentDetail();
  }

  pullToRefreshHandler = () => {
    this.initilizeAppointmentDetail();
  }

  initilizeAppointmentDetail = () => {
    this.props.setHeader({ type: HEADER.UPDATE_HEADER, showHeader: true, headerTitle: 'Appointment Details', hasBackButton: true, backButtonIcon: 'close' });
    return Promise.all([this.props.appointmentsFetch(),
      this.props.referralFetch()]);
  }

  navigateHandler = (appointment) => {
    const contactKey = _.get(appointment, 'contactIDs[0].id', '');
    this.props.navigateToReferralDetailPage(`/referraldetails/${contactKey}/appointment/${appointment.id}`);
  }

  render () {
    var appointment = appointmentActions.getAppointmentById(this.props.appointments, this.props.match.params.appointmentId) || {};
    var referral = referralActions.getReferralByAppointment(this.props.referrals, appointment) || {};

    if (referral === null || appointment === null) {
      return <ContentLoader isLoading={referral === null || appointment === null} />;
    }

    return (
      <section className='page-content appointments-page details-page'>
        {/* <PullToRefresh
          onRefresh={this.pullToRefreshHandler}
          spinnerOffset={10}
          distThreshold={100}
          spinnerColor='0000FF'
        > */}
        <div className='date-view-container'>
          <DateDivider date={appointment.startDate} />
          <div onClick={() => this.navigateHandler(appointment)}>
            <DataRow appointment={appointment} />
          </div>
          {
            appointment.opportunityKeys &&
            appointment.opportunityKeys.map((oppKey, index) => {
              const opp = referral.opportunities && referral.opportunities.find(opp => opp.opportunityKey === oppKey);
              const imageUrl = _.get(opp, 'contactProperty.property.imageUrl', null);
              if (imageUrl) {
                return (
                  <div key={index} className='appointment-property-image'>
                    <img className='show-image' src={imageUrl} />
                  </div>
                );
              }
            })
          }
        </div>
        <div className='appointment-actions'>
          <button className='btn btn-blue' onClick={() => this.props.cancelAppointment(appointment.id)}>Cancel</button>
          <button className='btn btn-blue' onClick={() => this.props.rescheduleAppointment(appointment.id)}>Reschedule</button>
          <button className='btn btn-blue' onClick={() => this.props.completeAppointment(appointment.id)}>Complete</button>
        </div>
        {/* </PullToRefresh> */}
      </section>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    appointments: state.appointments,
    referrals: state.referrals
  };
};

const mapDispatchToProps = dispatch => ({
  appointmentsFetch: bindActionCreators(appointmentActions.fetch, dispatch),
  referralFetch: bindActionCreators(referralActions.fetch, dispatch),
  setHeader: bindActionCreators(headerActions.setHeader, dispatch),
  cancelAppointment: bindActionCreators((id) => redirectToRoute(`/appointmentaction/cancel/${id}`, { headerTitle: 'Cancel Appointment' }, { from: 'appointmentDetails' }), dispatch),
  rescheduleAppointment: bindActionCreators((id) => redirectToRoute(`/appointmentaction/reschedule/${id}`, { headerTitle: 'Reschedule Appointment' }, { from: 'appointmentDetails' }), dispatch),
  completeAppointment: bindActionCreators((id) => redirectToRoute(`/appointmentaction/complete/${id}`, { headerTitle: 'Complete Appointment' }, { from: 'appointmentDetails' }), dispatch),
  navigateToReferralDetailPage: bindActionCreators(redirectToRoute, dispatch)
});
export default connect(mapStateToProps, mapDispatchToProps)(withRouter(AppointmentDetails));
